import { Box, Button, Stack, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

import { BaseLayout } from '@/components/layouts'
import { useRouter } from '@/core'
import { Template } from '@/core/architecture'

export * from './fragments'

export type State = {}

export type Action = {}

/**
 * 抽選応募をキャンセルした際に表示するページ
 * https://zpl.io/zwkq0Q3
 */
export const LotteryApplicationDetailCancelCompletionTemplate: Template<
  State,
  Action
> = () => {
  const { t } = useTranslation('lotteryApplicationDetailCancelCompletion')
  const { routerPages } = useRouter()

  return (
    <BaseLayout
      header={{
        title: t('title'),
      }}
      sx={{ height: '100%' }}
    >
      <Box
        sx={{
          width: '100%',
          height: '100%',
          display: 'grid',
          placeItems: 'center',
        }}
      >
        <Stack
          sx={{
            textAlign: 'center',
            alignItems: 'center',
          }}
        >
          <Typography variant="h5"> {t('head')}</Typography>
          <Typography variant="body2" sx={{ mt: 6 }}>
            {t('desc')}
          </Typography>
          <Button
            size="large"
            href={routerPages.LotteryApplications}
            sx={{ width: '212px', mt: '44px' }}
          >
            {t('toList')}
          </Button>
          <Button
            variant="text"
            href={routerPages.GlobalHome}
            sx={{ mt: '20px' }}
          >
            {t('topPage')}
          </Button>
        </Stack>
      </Box>
    </BaseLayout>
  )
}
